export function iterationMap<T>(times: number, cb: (index: number) => T) {
  return Array.from({ length: times }, (_, i) => cb(i));
}
